import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTax = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#f97c7c",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "DocumentType",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Tax",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Vector",
					d: "M1.5 14.5H14.5",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_2",
					d: "M14.5 6H1.5L7.49795 1.19845C7.64771 1.06888 7.82198 1 8 1C8.17802 1 8.35229 1.06888 8.50205 1.19845L14.5 6Z",
					fill: "currentColor",
					fillOpacity: .25,
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector 111",
					d: "M4 8.25V12.25",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector 112",
					d: "M8 8.25V12.25",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector 113",
					d: "M12 8.25V12.25",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		})
	})
});
export default SvgTax;
